import React, { useState, useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { Row, Col, Modal, Spinner } from 'react-bootstrap';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { useDispatch, useSelector } from 'react-redux';
import CountryForm from './CountryForm';
import { DELETE_COUNTRY, FETCH_COUNTRY, GET_COUNTRY } from 'actions/address';
import { startsWith } from 'components/common/utils';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import DeleteModal from 'components/general/DeleteModal';
import { DELETE_STATUS_CODE } from 'components/common/constant';
import { BiSort } from 'react-icons/bi';

const CountryList = () => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [allCountryData, setAllCountryData] = useState([]);
  const [countryId, setCountryId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseCountryData, setPageWiseCountryData] = useState([]);

  const countryList = useSelector((state) => state.country.countries);
  const isLoader = useSelector((state) => state.country.isLoading);
  const page = useSelector((state) => state.country.page);
  const totalData = useSelector((state) => state.country.total);
  const limit = useSelector((state) => state.country.limit);
  const totalPages = useSelector((state) => state.country.totalPages);

  const countryData = countryList.filter(({ id: id1 }) => pageWiseCountryData.some(({ id: id2 }) => id2 === id1));

  const getCountry = useCallback(
    (data = {}) => {
      dispatch({
        type: FETCH_COUNTRY,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              setPageWiseCountryData(res.data.results);
            }
          }
        },
      });
    },
    [pageWiseCountryData]
  );

  const getCountryDetail = useCallback((id) => {
    dispatch({ type: GET_COUNTRY, payload: id });
  }, []);

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setCountryId('');
  };

  const deleteCountry = useCallback(
    () =>
      dispatch({
        type: DELETE_COUNTRY,
        payload: countryId,
        cb: (res) => {
          if (_.get(res, 'status', '') === DELETE_STATUS_CODE) {
            handleCloseDeleteModel();
            getCountry({ page });
          }
        },
      }),
    [countryId]
  );

  useEffect(() => {
    getCountry();
  }, []);

  useEffect(() => {
    setAllCountryData(
      _.filter(countryData, (item) => startsWith(_.get(item, 'name', ''), searchText) || startsWith(_.get(item, 'country_code', ''), searchText))
    );
  }, [searchText, countryList, pageWiseCountryData]);

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getCountry(data);
      }
    },
    [sortByItem]
  );

  const handleCloseFormCountry = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getCountry(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getCountry(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title="Country" />
        <div className="page-content-wrapper scrollable">
          <div className="countryList-page">
            <Card>
              <div className="countryList-page-wrapper">
                <Row className="countryList-search-box">
                  <Col xl={10} lg={9} md={8} className="countryList-search-inputBox">
                    <SearchBox value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                  </Col>
                  <Col xl={2} lg={3} md={4} className="countryList-search-boxButton">
                    <Button
                      className="countryList-search-box-Btn"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      Add Country
                    </Button>
                  </Col>
                </Row>
                <div className="countryList-table">
                  <div className="table-responsive">
                    <table className="record-list-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Country Name</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Country Code</span>
                              <span className="ico" onClick={() => handleSorting('country_code', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th className="action-col">
                            <span>Action</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {isLoader ? (
                          <tr>
                            <td colSpan={10} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(allCountryData) ? (
                          <tr>
                            <td colSpan={6} className="border-0">
                              <div className="empty-data-block">No Country Data</div>
                            </td>
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(allCountryData, (item, key) => {
                            return (
                              <tr key={`country-${key}`}>
                                <td>{_.get(item, 'name')}</td>
                                <td>{_.get(item, 'country_code')}</td>
                                <td>
                                  <span
                                    className="countryList-table-editIcon"
                                    onClick={() => {
                                      setShowForm(true);
                                      getCountryDetail(_.get(item, 'id'));
                                      setIsEdit(true);
                                    }}
                                  >
                                    <FiEdit2 />
                                  </span>
                                  <span
                                    className="countryList-table-deleteIcon"
                                    onClick={() => {
                                      setShowDeleteModal(true);
                                      setCountryId(_.get(item, 'id', ''));
                                    }}
                                  >
                                    <RiDeleteBinLine />
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                    {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(allCountryData) && (
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                      // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                    )}
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {showForm && (
          <Modal show={showForm} size="lg" centered>
            <CountryForm onClose={handleCloseFormCountry} isEdit={isEdit} onSuccess={getCountry} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="country" onClose={handleCloseDeleteModel} onRemove={deleteCountry} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};
export default CountryList;
